import React from "react";
import QuestionItem from "../components/QuestionItem";
import QuestionsAnswersArray from "../components/QuestionsAnswersArray";
import BaseQuestions from "./Base";
import useQuestions from "../hooks/useQuestions";

const StudyDesignQuestions = ({
  globalId,
  wizardForm,
  // singleArm,
  // multipleArm,
  // doseFinding,
}) => {
  const { questionsData } = useQuestions();

  return (
    <form name={"wizardForm"}>
      {/* ── Q1, Q1a, Q2, Q3 – shared across all flows ── */}
      <BaseQuestions globalId={globalId} wizardForm={wizardForm} />

      {/* ════════════════════════════════════════════════
          SINGLE ARM  (qComparative === "false")
          ════════════════════════════════════════════════ */}
      {/* Q4 – multiple columns (single-arm) */}
      <QuestionItem
        questionIndex={"4"}
        questionName={"qSingleArmMultipleColumns"}
        activator={wizardForm.controls.qComparative.value === "false"}
        questionInputType={"richtext"}
      />
      <QuestionItem
        questionIndex={"5"}
        questionName={"qDemPopulation"}
        activator={wizardForm.controls.qComparative.value === "false"}
        questionInputType={"text"}
      />
      <QuestionItem
        questionIndex={"6"}
        questionName={"qCutOffsForDemographicsTables"}
        activator={wizardForm.controls.qComparative.value === "false"}
        questionInputType={"text"}
      />

      {/* ════════════════════════════════════════════════
          MULTIPLE ARM & DOSE FINDING  (qComparative === "true")
          ════════════════════════════════════════════════ */}

      {/* Q4 – dose-finding toggle */}
      <QuestionItem
        questionIndex={"4"}
        questionName={"qDoseFinding"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"radio"}
        questionInputChoice={"yes_no"}
        globalId={globalId}
      />

      {/* Q4a – Dose Finding: safety sub-toggle */}
      <QuestionItem
        questionIndex={"4a"}
        questionName={"qDoseFindingSafety"}
        activator={
          wizardForm.controls.qComparative.value === "true" &&
          wizardForm.controls.qDoseFinding.value === "true"
        }
        questionInputType={"radio"}
        questionInputChoice={"yes_no"}
        globalId={globalId}
      />

      {/* Q4a1 – Dose Finding WITH safety: dose-group names */}
      <QuestionsAnswersArray
        questionIndex={"4a1"}
        controlName={"qTgNamesDoseFinding"}
        activator={
          wizardForm.controls.qDoseFinding.value === "true" &&
          wizardForm.controls.qDoseFindingSafety?.value === "true" &&
          wizardForm.controls.qComparative.value === "true"
        }
        formGroup={wizardForm}
        minInputs={2}
        inputTextBoxes={[["Column Header", "name", "richtext"]]}
      />

      {/* Q4a1 – Dose Finding WITHOUT safety: treatment-group names */}
      <QuestionsAnswersArray
        questionIndex={"4a1"}
        controlName={"qTgNames"}
        activator={
          wizardForm.controls.qDoseFinding.value === "true" &&
          wizardForm.controls.qDoseFindingSafety?.value === "false"
        }
        formGroup={wizardForm}
        minInputs={2}
        inputTextBoxes={[
          ["Column Header", "name", "richtext"],
          ["Role", "role", "select"],
        ]}
        inputTextBoxesAdditionalData={{
          role: questionsData?.current?.choices?.qTgNames,
        }}
      />

      {/* Q4a – Multiple Arm: treatment-group names */}
      <QuestionsAnswersArray
        questionIndex={"4a"}
        controlName={"qTgNames"}
        activator={
          wizardForm.controls.qComparative.value === "true" &&
          wizardForm.controls.qDoseFinding.value === "false"
        }
        formGroup={wizardForm}
        minInputs={2}
        inputTextBoxes={[
          ["Column Header", "name", "richtext"],
          ["Role", "role", "select"],
        ]}
        inputTextBoxesAdditionalData={{
          role: questionsData?.current?.choices?.qTgNames,
        }}
      />

      {/* Q4b – Multiple Arm: comparison pairs */}
      <QuestionsAnswersArray
        questionIndex={"4b"}
        controlName={"qTgNamesComparison"}
        activator={
          wizardForm.controls.qComparative.value === "true" &&
          wizardForm.controls.qDoseFinding.value === "false"
        }
        formGroup={wizardForm}
        inputTextBoxes={[
          ["Treatment", "Treatment", "select"],
          ["Comparator", "Comparator", "select"],
        ]}
        inputTextBoxesAdditionalData={"updateTgNamesComparisonAdditionalData"}
      />

      {/* Q5 – participant number */}
      <QuestionItem
        questionIndex={"5"}
        questionName={"qParticipantNumber"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"radio"}
        questionInputChoice={"qParticipantNumber"}
        globalId={globalId}
      />

      {/* Q7 – intended duration – hidden per manager request; logic/handlers kept intact
      <QuestionItem
        questionIndex={"7"}
        questionName={"qIntendedDuration"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"radio"}
        questionInputChoice={"yes_no"}
        globalId={globalId}
      />
      */}

      {/* Q8 – demographics population */}
      <QuestionItem
        questionIndex={"6"}
        questionName={"qDemPopulation"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"text"}
      />

      {/* Q9 – demographics cut-offs */}
      <QuestionItem
        questionIndex={"7"}
        questionName={"qCutOffsForDemographicsTables"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"text"}
      />
    </form>
  );
};

export default StudyDesignQuestions;
